module.exports = __webpack_public_path__ + "img/ship1.c418d295.png";